import React, { useEffect } from 'react';
import { UpcomingEvents } from '../landing/UpcomingEventsLanding';
import { Box } from '@spothero/ui';
import { useSelector } from 'react-redux';
import StorageUtils from '@spothero/utils/storage';
import SegmentUtils from 'utils/segment';
export const VenueEventEdit = () => {
    const title = useSelector((state) => state.destination.data.title);
    const searchString = useSelector((state) => state.searchRequest.search_string);
    useEffect(() => {
        const userLatLng = StorageUtils.get('sh-user-location', 'session');
        SegmentUtils.track({
            event: 'Event List Display',
            properties: {
                /* eslint-disable camelcase */
                ...(userLatLng && { user_location: userLatLng }),
                ...(searchString && { search_query: searchString }),
                destination: title,
                /* eslint-enable camelcase */
            },
        });
    }, [searchString, title]);
    return (<Box data-testid="VenueEventEdit" flex={{
            tablet: '1 1 80%',
            desktop: '1 1 65%',
            desktopXL: '1 1 50%',
        }} display="grid" gridTemplateRows="min-content">
            <UpcomingEvents />
        </Box>);
};
